import React from "react";
import AllCities from "../components/cities-all"
import LayoutDumpster from "../components/layout-dumpster";

const ALLCITIESDUMPSTER = ({ pageContext }) => 
{	
	const env = pageContext.env;
    const code = pageContext.code;
    const codes = pageContext.codes;
	const cities = pageContext.cities.length > 0 ? pageContext.cities : [];
    const state = pageContext.state;		
    const seo_desc = pageContext.seo_desc;
    const seo = 
    {
        url: pageContext.url,
        env: env,
        code: code,
        page: 'allstate',
		state: state,
        seo_desc: seo_desc
    }
    
    return (
		<LayoutDumpster seo={seo} env={env} >   

			<AllCities cities={cities} state={state} code={code} codes={codes} />
  
        </LayoutDumpster>
	)
};

export default ALLCITIESDUMPSTER;